import { gql } from "graphql-request"

export const activeProjects = gql`
  query ActiveProjects {
    active_projects {
      id
      name
    }
  }
`
